import { useEffect } from "react";

/**
 * Silent OAuth Callback
 * Runs in hidden iframe for automatic login detection
 * Sends result to parent window via postMessage
 */
const SilentCallback = () => {
  useEffect(() => {
    handleSilentCallback();
  }, []);

  const handleSilentCallback = () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      const error = urlParams.get("error");
      const errorDescription = urlParams.get("error_description");

      console.log("[Silent Callback] Processing:", { hasCode: !!code, error });

      if (code) {
        // Success - user is logged in, send code to parent
        window.parent.postMessage(
          {
            type: "SILENT_AUTH_SUCCESS",
            code: code,
          },
          window.location.origin
        );

        console.log("[Silent Callback] ✅ Success message sent");
      } else if (error) {
        // Failed - user not logged in or error occurred
        window.parent.postMessage(
          {
            type: "SILENT_AUTH_FAILED",
            error: error,
            errorDescription: errorDescription,
          },
          window.location.origin
        );

        console.log("[Silent Callback] ❌ Failed:", error);
      } else {
        // No code or error - unexpected
        window.parent.postMessage(
          {
            type: "SILENT_AUTH_FAILED",
            error: "no_response",
            errorDescription: "No authorization code or error received",
          },
          window.location.origin
        );

        console.log("[Silent Callback] ⚠️ No response");
      }
    } catch (error) {
      console.error("[Silent Callback] Error:", error);

      window.parent.postMessage(
        {
          type: "SILENT_AUTH_FAILED",
          error: "callback_error",
          errorDescription: error.message,
        },
        window.location.origin
      );
    }
  };

  // This component renders nothing (it's in a hidden iframe)
  return null;
};

export default SilentCallback;
